import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

/**
 * Tag Sourcing save service.
 * Original AngularJS: tagSourcingServiceFactory.saveTagData, action_code=wlslig
 */
@Injectable({
  providedIn: 'root'
})
export class TagSourcingService {

  constructor(private http: HttpClient) {}

  saveTagData(
    baseUrl: string,
    formData: {
      tagKey?: string;
      gieKey?: string;
      actKey?: string;
      combinationKey?: string;
      dropdown?: string;
      amount?: string;
      transType?: string;
    },
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject';
    const jsonObj = formData;
    const jsonSettings = globalService?.globalParams || globalService || {};
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams || {});
    params.clob_settings = JSON.stringify(jsonSettings);
    params.clob_data = JSON.stringify(jsonObj);
    params.action_code = 'wlslig';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
